import BaseModelAPI from '../BaseModelAPI';

export default class MaintenanceHistoryList extends BaseModelAPI {

	static entity = 'maintenancehistorylist'
	static entityName = 'maintenancehistory';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
